import type { ReactNode } from 'react';
import { Tooltip, type TooltipPlacement } from '@skupreme/shared/ui';
import { tooltipTexts } from '@utility/constants/common';

type PermissionGateProps = {
  children: ReactNode;
  /** The action is shown but cannot run; the tooltip says why. */
  disabled: boolean;
  /** The action is not offered at all. */
  hidden: boolean;
  placement?: TooltipPlacement;
};

export function PermissionGate({
  children,
  disabled,
  hidden,
  placement = 'top',
}: PermissionGateProps) {
  if (hidden) {
    return null;
  }

  return (
    <Tooltip
      content={tooltipTexts.missingPermission}
      placement={placement}
      isDisabled={!disabled}
    >
      {children}
    </Tooltip>
  );
}
